export default "__VITE_ASSET__0fb10cfa__"